/* @flow */

import axios from 'axios';
import type { $AxiosXHR } from 'axios';
import type { $Activity } from 'CoreTypes';
import type { $Brand } from 'CoreTypes';
import type { $Dealer } from 'CoreTypes';
import type { $ProductGroup } from 'CoreTypes';
import type { $SearchResults } from 'CoreTypes';
import type { $SearchRequest } from 'CoreTypes';
import ServiceConsumer from './ServiceConsumer';
import { encodeRequestQueryData } from '../utils/WidgetUtils';

type $AddressSuggestionRequest = {
  address: string,
  marketCode: string,
  maxResults?: number
};

export default class DMSConsumer extends ServiceConsumer {

  constructor(dealerServiceEndpoint: string) {
    super(dealerServiceEndpoint);
  }

  getDealerDataByExternalId = (
    outletId: string,
    marketCode: string,
    localeLanguage: boolean = false
  ): Promise<$Dealer | null> => {
    let endpoint = `${this.endpointUrl}/dealers/search?marketCode=${marketCode}&fields=*&whiteList=${outletId}`;

    if (localeLanguage) {
      endpoint += `&localeLanguage=${String(localeLanguage)}`;
    }

    return axios
      .get(endpoint)
      .then(response => response.data)
      .then(data => data.results ? data.results[0] : null);
  }

  searchDealersByCriteria = (req: Object): Promise<$AxiosXHR<$SearchResults>> =>
    axios.post(`${this.endpointUrl}/dealers/search`, req);

  searchDealersFullText = (params: $SearchRequest): Promise<$AxiosXHR<$SearchResults>> => {
    const query = encodeRequestQueryData(params);
    return axios.get(`${this.endpointUrl}/dealers/search?${query}`);
  }

  getActivities = (): Promise<$AxiosXHR<Array<$Activity>>> =>
    axios.get(`${this.endpointUrl}/activities`);

  getBrands = (): Promise<$AxiosXHR<Array<$Brand>>> =>
    axios.get(`${this.endpointUrl}/brands`);

  getProductGroups = (): Promise<$AxiosXHR<Array<$ProductGroup>>> =>
    axios.get(`${this.endpointUrl}/product-groups`);

  getDealersSuggestedList = (): Promise<$AxiosXHR<Array<string>>> =>
    axios.get(`${this.endpointUrl}/dealers/suggest/externalIds`);

  getAddressSuggestions = (params: $AddressSuggestionRequest) => {
    const query = encodeRequestQueryData(params);
    return axios.get(`${this.endpointUrl}/geocoding/autocomplete?${query}`);
  }
}
